'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHoc = require('@mindz/react-hoc');

var _Calendar = require('../Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _DatePickerDefaultModule = require('./DatePicker.default.module.css');

var _DatePickerDefaultModule2 = _interopRequireDefault(_DatePickerDefaultModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CalendarIcon = function CalendarIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('g', {
    fill: '#009FFD'
  }, _react2.default.createElement('path', {
    d: 'M15.375 12.903c.345 0 .625.942.625.597V3.75c0-1.378-1.121-2.5-2.5-2.5h-.813V.625a.625.625 0 1 0-1.25 0v.625H8.595V.625a.625.625 0 1 0-1.25 0v.625H4.53V.625a.625.625 0 1 0-1.25 0v.625H2.5A2.503 2.503 0 0 0 0 3.75v9.75C0 14.879 1.121 16 2.5 16h11c1.379 0 2.5-1.121 2.5-2.5a.625.625 0 1 0-1.25 0c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h.781v.625a.625.625 0 1 0 1.25 0V2.5h2.813v.625a.625.625 0 1 0 1.25 0V2.5h2.844v.625a.625.625 0 1 0 1.25 0V2.5h.812c.69 0 1.25.56 1.25 1.25v10.185c0 .346.28-1.032.625-1.032z'
  }), _react2.default.createElement('circle', {
    cx: '3.906',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '9.344',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '12.063',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '3.906',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '3.906',
    cy: '12',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '6.625',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '6.625',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '6.625',
    cy: '12',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '9.344',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '12.063',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '9.344',
    cy: '12',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  })));
};

CalendarIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16'
};

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _this.state = {
      isDatePickerShown: false,
      labelText: _this.props.placeholder,
      date: ''
    }, _this.handleOutsideClick = function (event) {
      if (_this.node && !_this.node.contains(event.target)) {
        _this.setState({
          isDatePickerShown: false
        });
      }
    }, _this.handleChange = function (date) {
      var handleChange = _this.props.handleChange;
      handleChange(date);

      _this.setState({
        labelText: date,
        date: date
      });
    }, _this.reset = function () {
      var placeholder = _this.props.placeholder;

      _this.setState({
        labelText: placeholder,
        date: ''
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DatePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          placeholder = _props.placeholder,
          initialDate = _props.initialDate;
      this.setState({
        labelText: placeholder,
        date: initialDate
      });
      document.addEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          cx = _props2.cx,
          label = _props2.label,
          isInputField = _props2.isInputField,
          Image = _props2.Image,
          error = _props2.error,
          headerLabel = _props2.headerLabel,
          headerSecondLabel = _props2.headerSecondLabel,
          placeholder = _props2.placeholder,
          newStyles = _props2.newStyles;
      var _state = this.state,
          isDatePickerShown = _state.isDatePickerShown,
          labelText = _state.labelText,
          date = _state.date;
      return _react2.default.createElement('div', {
        className: cx('root', {
          active: isDatePickerShown,
          isInputField: isInputField,
          selected: date.length > 0,
          hasError: !!error,
          headerLabel: headerLabel,
          kauflandRed: newStyles === 'kauflandRed'
        }),
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, _react2.default.createElement('div', {
        className: cx('header-label')
      }, headerLabel), _react2.default.createElement('div', {
        className: cx('header-second-label')
      }, headerSecondLabel), isInputField ? _react2.default.createElement('div', {
        className: cx('indicator'),
        onClick: function onClick() {
          return _this2.setState(function (prevState) {
            return {
              isDatePickerShown: !prevState.isDatePickerShown
            };
          });
        }
      }, _react2.default.createElement('div', {
        className: cx('title')
      }, _react2.default.createElement('span', {
        className: cx('text')
      }, date), _react2.default.createElement('span', {
        className: cx('label')
      }, label)), _react2.default.createElement(CalendarIcon, {
        className: cx('calendarIcon')
      })) : _react2.default.createElement('div', {
        className: cx('indicator', {
          isImage: Image
        }),
        onClick: function onClick() {
          return _this2.setState(function (prevState) {
            return {
              isDatePickerShown: !prevState.isDatePickerShown
            };
          });
        }
      }, label && _react2.default.createElement('span', {
        className: cx('label')
      }, label, ':'), _react2.default.createElement('span', {
        className: cx('labelText', {
          noDate: labelText === placeholder
        })
      }, labelText), Image && _react2.default.createElement(Image, {
        className: cx('image')
      })), isInputField && this.renderError(), this.renderDropdown());
    }
  }, {
    key: 'renderDropdown',
    value: function renderDropdown() {
      var _props3 = this.props,
          cx = _props3.cx,
          align = _props3.align,
          resetCalendarText = _props3.resetCalendarText;
      var isDatePickerShown = this.state.isDatePickerShown;

      if (!isDatePickerShown) {
        return null;
      }

      return _react2.default.createElement('div', {
        className: cx('dropdown', {
          left: align === 'left' ? true : false,
          center: align === 'center' ? true : false
        })
      }, this.renderCalendar(), _react2.default.createElement('span', {
        className: cx('reset'),
        onClick: this.reset
      }, resetCalendarText));
    }
  }, {
    key: 'renderCalendar',
    value: function renderCalendar() {
      var _this3 = this;

      var _props4 = this.props,
          cx = _props4.cx,
          language = _props4.language,
          dateFormat = _props4.dateFormat,
          newStyles = _props4.newStyles;
      var date = this.state.date;
      return _react2.default.createElement('div', {
        className: cx('calendarHolder')
      }, _react2.default.createElement(_Calendar2.default, {
        dateFormat: dateFormat,
        language: language,
        date: date,
        getDateString: function getDateString(date) {
          _this3.handleChange(date);

          _this3.setState({
            isDatePickerShown: false
          });
        },
        newStyles: newStyles
      }));
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      var _props5 = this.props,
          cx = _props5.cx,
          error = _props5.error;

      if (Array.isArray(error)) {
        return _react2.default.createElement('div', {
          className: cx('error', {
            shown: !!error[0]
          })
        }, error[0]);
      }

      return _react2.default.createElement('div', {
        className: cx('error', {
          shown: !!error
        })
      }, error);
    }
  }]);

  return DatePicker;
}(_react.Component);

DatePicker.defaultProps = {
  placeholder: 'Any',
  resetCalendarText: 'Reset calendar',
  initialDate: '',
  language: 'pl-PL',
  dateFormat: 'DD/MM/YYYY',
  handleChange: function handleChange() {}
};
exports.default = (0, _reactHoc.withStyles)(_DatePickerDefaultModule2.default)(DatePicker);
module.exports = exports.default;